<div class="td-overall-view">
  <div class="td-cards-row">
    <div class="td-card td-overall-score-card">
      <span class="td-card-title">{{ 'td_overall_score' | translate }}</span>
      <div class="td-overall-score-gauge" *ngIf="overallScore">
        <app-gauge-display
          [value]="overallScore.score"
          [width]="190"
          [height]="165"
          [isOnTeamCodex]="true"
          [trend]="overallScore.trend"
          [colorStart]="overallScore.color"
          [colorEnd]="overallScore.color"
          [backgroundColor]="'rgba(240, 243, 250, 1)'">
        </app-gauge-display>
      </div>
      <div class="td-overall-change-box" *ngIf="overallScore">
        <div class="td-overall-change-value">
          <span class="td-overall-change-arrow" *ngIf="overallScore.trend"
                [ngClass]="overallScore.trend">
            <img [src]="'../../../assets/svg/indicator-arrow-' + overallScore.trend + '.svg'" alt="">
          </span>
          <i class="bi bi-dash-lg td-overall-change-dash" *ngIf="!overallScore.trend"></i>
          <span class="td-overall-change-diff">{{ (overallScore.diff !== null ? overallScore.diff : 0) }}%</span>
        </div>
        <span class="td-overall-change-label">{{ 'td_overall_score_change' | translate }}</span>
      </div>
      <div class="td-overall-basis" *ngIf="overallScore">
        <span>{{ 'td_overall_score_basis' | translate : {count: overallScore.teamsCount} }}</span>
        <span>{{ periodLabel }}</span>
      </div>
    </div>

    <app-pyramid class="td-card-slot"
                 [categories]="pyramidCategories"
                 [legend]="pyramidLegend"
                 (categorySelected)="onCategorySelected($event)">
    </app-pyramid>

    <app-score-development class="td-card-slot"
                           [scores]="scoreDevelopment"
                           [chips]="scoreDevelopmentChips"
                           [activeChipUuid]="activeChipUuid"
                           [loading]="loadingScoreDevelopment"
                           (chipSelected)="onChipSelected($event)">
    </app-score-development>
  </div>

  <app-team-overview
    [data]="teamOverview"
    [loading]="loadingTeamOverview"
    (filtersChanged)="onTeamOverviewFiltersChanged($event)">
  </app-team-overview>
</div>
